const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88c057"
    },
    cx: 29,
    cy: 29,
    r: 29
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbce9d"
    },
    d: "M52.932,45.376C52.275,38.985,46.876,34,40.311,34h-5.946C33.611,34,33,33.389,33,32.635V31.99 c0-0.583,0.379-1.082,0.925-1.287c5.804-2.182,9.778-11.704,8.971-18.433C42.134,5.919,36.97,0.801,30.614,0.09 c-0.517-0.058-1.029-0.086-1.535-0.088c-0.016,0-0.032-0.001-0.048-0.001C21.285-0.016,15,6.258,15,14 c0,6.024,3.807,14.755,9.145,16.729C24.668,30.922,25,31.442,25,32v0.635C25,33.389,24.389,34,23.635,34h-5.946 c-6.565,0-11.964,4.985-12.621,11.376C10.293,52.998,19.061,58,29,58S47.707,52.998,52.932,45.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5411e"
    },
    d: "M33.492,6.61c3.715,1.021,7.213,3.306,9.453,6.322c-0.016-0.221-0.023-0.447-0.049-0.663 C42.134,5.919,36.97,0.801,30.614,0.09c-0.517-0.058-1.029-0.086-1.535-0.088c-0.016,0-0.032-0.001-0.048-0.001 c-6.92-0.015-12.66,4.995-13.808,11.583l0.005,0c0.179,0.252,0.354,0.507,0.545,0.75c0.07-0.087,0.141-0.173,0.213-0.258 c2-2.38,5.341-2.931,8.183-1.671C25.034,10.787,25.992,11,27,11C29.942,11,32.456,9.182,33.492,6.61z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 34,
    style: {
      fill: "#424a60"
    },
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 34,
    style: {
      fill: "#424a60"
    },
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M14,50.383v3.44C18.377,56.474,23.51,58,29,58s10.623-1.526,15-4.177v-3.44V42H14V50.383z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.421c216cade798655b7258e05973f632.svg";
export { ForwardRef as ReactComponent };